// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonPill-module_commonButton__K0deP {
    font: var(--typography-main);
    border: none;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    vertical-align: top;
    cursor: pointer;
    pointer-events: auto;
    border-radius: 56px;
}

.buttonPill-module_truncateText__C23hg {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media screen and (min-width: 708px) {
    .buttonPill-module_commonButton__K0deP {
        max-width: var(--customMaxWidth);
    }
}

/*      Box shadow  */
.buttonPill-module_boxShadowGrey__SHAqv {
    box-shadow: var(--shadow_grey);
}

.buttonPill-module_boxShadowPurple__CqRb3 {
    box-shadow: var(--shadow_purple);
}

/*      Font size       */
.buttonPill-module_fontSizeSmall__wjvX6 {
    font: var(--typography-secondary);
}

.buttonPill-module_fontSizeMedium__RGf1x {
    border-radius: 32px;
}

.buttonPill-module_regularContainer__mwDGK {
    width: auto;
}

.buttonPill-module_disabled__T80RH {
    cursor: default;
}

/*      Padding     */
.buttonPill-module_paddingMedium__15E8Z {
    padding: 8px 16px;
}

.buttonPill-module_padding__mp_iB {
    padding: 16px 32px;
}

.buttonPill-module_paddingSmall__KNOVH {
    padding: 4px 16px;
}

.buttonPill-module_paddingSmallIconRight__qKlgG {
    padding: 4px 8px 4px 16px;
}

.buttonPill-module_paddingSmallIconLeft__ztDdd {
    padding: 4px 16px 4px 8px;
}

/*     Background Color    */
.buttonPill-module_backgroundWhite__ChvOb {
    background: var(--white);
}

.buttonPill-module_backgroundWhiteBase__YdK98 {
    background: var(--white_0_tr_base);
}

.buttonPill-module_backgroundGrey__zNdx8 {
    background: var(--grey_40_lc);
}

.buttonPill-module_backgroundPurple16Lc__eWG0O {
    background: var(--purple_16_lc);
}

.buttonPill-module_backgroundPurple100__Fracc {
    background: var(--purple_100);
}

/*      Text Color      */
.buttonPill-module_colorPurple_100__OHy8G {
    color: var(--purple_100);
}

.buttonPill-module_colorPurple_100__OHy8G:link,
.buttonPill-module_colorPurple_100__OHy8G:visited,
.buttonPill-module_colorPurple_100__OHy8G:focus-visible {
    color: var(--purple_100);
}

@media (hover: hover) and (pointer: fine) {
    .buttonPill-module_colorPurple_100__OHy8G:hover {
        background: var(--purple_16_lc);
        color: var(--purple_100);
    }
}

.buttonPill-module_colorPurple_100__OHy8G:active,
.buttonPill-module_colorPurple_100__OHy8G:focus-visible {
    background: var(--purple_8_lc);
    color: var(--purple_100);
}

.buttonPill-module_colorPurple_40_tr__l4e0g {
    color: var(--purple_40_tr);
}

.buttonPill-module_colorPurple_40_tr__l4e0g:link,
.buttonPill-module_colorPurple_40_tr__l4e0g:visited,
.buttonPill-module_colorPurple_40_tr__l4e0g:focus-visible {
    color: var(--purple_40_tr);
}

@media (hover: hover) and (pointer: fine) {
    .buttonPill-module_colorPurple_40_tr__l4e0g:hover {
        background: var(--white);
        color: var(--purple_40_tr);
    }
}

.buttonPill-module_colorPurple_40_tr__l4e0g:active,
.buttonPill-module_colorPurple_40_tr__l4e0g:focus-visible {
    background: var(--white);
    color: var(--purple_40_tr);
}

.buttonPill-module_colorWhite_base__eA6Jl {
    color: var(--white_base);
}

.buttonPill-module_colorWhite_base__eA6Jl:link,
.buttonPill-module_colorWhite_base__eA6Jl:visited,
.buttonPill-module_colorWhite_base__eA6Jl:focus-visible {
    color: var(--white_base);
}

@media (hover: hover) and (pointer: fine) {
    .buttonPill-module_colorWhite_base__eA6Jl:hover {
        background: var(--purple_72_hc);
        color: var(--white_base);
    }
}

.buttonPill-module_colorWhite_base__eA6Jl:active,
.buttonPill-module_colorWhite_base__eA6Jl:focus-visible {
    background: var(--purple_72_lc);
    color: var(--white_base);
}

.buttonPill-module_colorWhite_base_gradient__oDBic {
    color: var(--white_base);
}

.buttonPill-module_colorWhite_base_gradient__oDBic:link,
.buttonPill-module_colorWhite_base_gradient__oDBic:visited,
.buttonPill-module_colorWhite_base_gradient__oDBic:focus-visible {
    color: var(--white_base);
}

@media (hover: hover) and (pointer: fine) {
    .buttonPill-module_colorWhite_base_gradient__oDBic:hover {
        background: var(--white_8_tr_base);
        color: var(--white_base);
    }
}

.buttonPill-module_colorWhite_base_gradient__oDBic:active,
.buttonPill-module_colorWhite_base_gradient__oDBic:focus-visible {
    background: var(--white_16_tr_base);
    color: var(--white_base);
}

.buttonPill-module_colorGrey_40_lc__l3nwv {
    color: var(--grey_40_lc);
}

.buttonPill-module_colorGrey_40_lc__l3nwv:link,
.buttonPill-module_colorGrey_40_lc__l3nwv:visited,
.buttonPill-module_colorGrey_40_lc__l3nwv:focus-visible {
    color: var(--grey_40_lc);
}

@media (hover: hover) and (pointer: fine) {
    .buttonPill-module_colorGrey_40_lc__l3nwv:hover {
        background: var(--white);
        color: var(--grey_40_lc);
    }
}

.buttonPill-module_colorGrey_40_lc__l3nwv:active,
.buttonPill-module_colorGrey_40_lc__l3nwv:focus-visible {
    background: var(--white);
    color: var(--grey_40_lc);
}

.buttonPill-module_colorBlack__bsyqK {
    color: var(--black);
}

.buttonPill-module_colorBlack__bsyqK:link,
.buttonPill-module_colorBlack__bsyqK:visited,
.buttonPill-module_colorBlack__bsyqK:focus-visible {
    color: var(--black);
}

@media (hover: hover) and (pointer: fine) {
    .buttonPill-module_colorBlack__bsyqK:hover {
        background: var(--grey_16_lc);
        color: var(--black);
    }
}

.buttonPill-module_colorBlack__bsyqK:active,
.buttonPill-module_colorBlack__bsyqK:focus-visible {
    background: var(--grey_8_lc);
    color: var(--black);
}

.buttonPill-module_colorWhite_40_tr_base__lrIAU {
    color: var(--white_40_tr_base);
}

.buttonPill-module_colorWhite_40_tr_base__lrIAU:link,
.buttonPill-module_colorWhite_40_tr_base__lrIAU:visited,
.buttonPill-module_colorWhite_40_tr_base__lrIAU:focus-visible {
    color: var(--white_40_tr_base);
}

@media (hover: hover) and (pointer: fine) {
    .buttonPill-module_colorWhite_40_tr_base__lrIAU:hover {
        background: var(--purple_16_lc);
        color: var(--white_40_tr_base);
    }
}

.buttonPill-module_colorWhite_40_tr_base__lrIAU:active,
.buttonPill-module_colorWhite_40_tr_base__lrIAU:focus-visible {
    background: var(--purple_16_lc);
    color: var(--white_40_tr_base);
}

.buttonPill-module_fillContainer__vKCg9 {
    width: 100%;
}

/*      Container for icons   */
.buttonPill-module_rightOrder__J5IOX {
    order: 2;
}

/*       Container margin   */
.buttonPill-module_containerMarginLeft4__tS_5v {
    margin-left: 4px;
}

.buttonPill-module_containerMarginLeft8__Kpekw {
    margin-left: 8px;
}

.buttonPill-module_containerMarginRight4__ObmLg {
    margin-right: 4px;
}

.buttonPill-module_containerMarginRight8__CjiHk {
    margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/buttonPill.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA,qBAAqB;AACrB;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA,yBAAyB;AACzB;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,yBAAyB;AACzB;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;IAGI,0BAA0B;AAC9B;;AAEA;IACI;QACI,wBAAwB;QACxB,0BAA0B;IAC9B;AACJ;;AAEA;;IAEI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI;QACI,kCAAkC;QAClC,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;AACJ;;AAEA;;IAEI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;IACI;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;AACJ;;AAEA;;IAEI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI,QAAQ;AACZ;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".commonButton {\n    font: var(--typography-main);\n    border: none;\n    box-sizing: border-box;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    position: relative;\n    vertical-align: top;\n    cursor: pointer;\n    pointer-events: auto;\n    border-radius: 56px;\n}\n\n.truncateText {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media screen and (min-width: 708px) {\n    .commonButton {\n        max-width: var(--customMaxWidth);\n    }\n}\n\n/*      Box shadow  */\n.boxShadowGrey {\n    box-shadow: var(--shadow_grey);\n}\n\n.boxShadowPurple {\n    box-shadow: var(--shadow_purple);\n}\n\n/*      Font size       */\n.fontSizeSmall {\n    font: var(--typography-secondary);\n}\n\n.fontSizeMedium {\n    border-radius: 32px;\n}\n\n.regularContainer {\n    width: auto;\n}\n\n.disabled {\n    cursor: default;\n}\n\n/*      Padding     */\n.paddingMedium {\n    padding: 8px 16px;\n}\n\n.padding {\n    padding: 16px 32px;\n}\n\n.paddingSmall {\n    padding: 4px 16px;\n}\n\n.paddingSmallIconRight {\n    padding: 4px 8px 4px 16px;\n}\n\n.paddingSmallIconLeft {\n    padding: 4px 16px 4px 8px;\n}\n\n/*     Background Color    */\n.backgroundWhite {\n    background: var(--white);\n}\n\n.backgroundWhiteBase {\n    background: var(--white_0_tr_base);\n}\n\n.backgroundGrey {\n    background: var(--grey_40_lc);\n}\n\n.backgroundPurple16Lc {\n    background: var(--purple_16_lc);\n}\n\n.backgroundPurple100 {\n    background: var(--purple_100);\n}\n\n/*      Text Color      */\n.colorPurple_100 {\n    color: var(--purple_100);\n}\n\n.colorPurple_100:link,\n.colorPurple_100:visited,\n.colorPurple_100:focus-visible {\n    color: var(--purple_100);\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .colorPurple_100:hover {\n        background: var(--purple_16_lc);\n        color: var(--purple_100);\n    }\n}\n\n.colorPurple_100:active,\n.colorPurple_100:focus-visible {\n    background: var(--purple_8_lc);\n    color: var(--purple_100);\n}\n\n.colorPurple_40_tr {\n    color: var(--purple_40_tr);\n}\n\n.colorPurple_40_tr:link,\n.colorPurple_40_tr:visited,\n.colorPurple_40_tr:focus-visible {\n    color: var(--purple_40_tr);\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .colorPurple_40_tr:hover {\n        background: var(--white);\n        color: var(--purple_40_tr);\n    }\n}\n\n.colorPurple_40_tr:active,\n.colorPurple_40_tr:focus-visible {\n    background: var(--white);\n    color: var(--purple_40_tr);\n}\n\n.colorWhite_base {\n    color: var(--white_base);\n}\n\n.colorWhite_base:link,\n.colorWhite_base:visited,\n.colorWhite_base:focus-visible {\n    color: var(--white_base);\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .colorWhite_base:hover {\n        background: var(--purple_72_hc);\n        color: var(--white_base);\n    }\n}\n\n.colorWhite_base:active,\n.colorWhite_base:focus-visible {\n    background: var(--purple_72_lc);\n    color: var(--white_base);\n}\n\n.colorWhite_base_gradient {\n    color: var(--white_base);\n}\n\n.colorWhite_base_gradient:link,\n.colorWhite_base_gradient:visited,\n.colorWhite_base_gradient:focus-visible {\n    color: var(--white_base);\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .colorWhite_base_gradient:hover {\n        background: var(--white_8_tr_base);\n        color: var(--white_base);\n    }\n}\n\n.colorWhite_base_gradient:active,\n.colorWhite_base_gradient:focus-visible {\n    background: var(--white_16_tr_base);\n    color: var(--white_base);\n}\n\n.colorGrey_40_lc {\n    color: var(--grey_40_lc);\n}\n\n.colorGrey_40_lc:link,\n.colorGrey_40_lc:visited,\n.colorGrey_40_lc:focus-visible {\n    color: var(--grey_40_lc);\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .colorGrey_40_lc:hover {\n        background: var(--white);\n        color: var(--grey_40_lc);\n    }\n}\n\n.colorGrey_40_lc:active,\n.colorGrey_40_lc:focus-visible {\n    background: var(--white);\n    color: var(--grey_40_lc);\n}\n\n.colorBlack {\n    color: var(--black);\n}\n\n.colorBlack:link,\n.colorBlack:visited,\n.colorBlack:focus-visible {\n    color: var(--black);\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .colorBlack:hover {\n        background: var(--grey_16_lc);\n        color: var(--black);\n    }\n}\n\n.colorBlack:active,\n.colorBlack:focus-visible {\n    background: var(--grey_8_lc);\n    color: var(--black);\n}\n\n.colorWhite_40_tr_base {\n    color: var(--white_40_tr_base);\n}\n\n.colorWhite_40_tr_base:link,\n.colorWhite_40_tr_base:visited,\n.colorWhite_40_tr_base:focus-visible {\n    color: var(--white_40_tr_base);\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .colorWhite_40_tr_base:hover {\n        background: var(--purple_16_lc);\n        color: var(--white_40_tr_base);\n    }\n}\n\n.colorWhite_40_tr_base:active,\n.colorWhite_40_tr_base:focus-visible {\n    background: var(--purple_16_lc);\n    color: var(--white_40_tr_base);\n}\n\n.fillContainer {\n    width: 100%;\n}\n\n/*      Container for icons   */\n.rightOrder {\n    order: 2;\n}\n\n/*       Container margin   */\n.containerMarginLeft4 {\n    margin-left: 4px;\n}\n\n.containerMarginLeft8 {\n    margin-left: 8px;\n}\n\n.containerMarginRight4 {\n    margin-right: 4px;\n}\n\n.containerMarginRight8 {\n    margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonButton": `buttonPill-module_commonButton__K0deP`,
	"truncateText": `buttonPill-module_truncateText__C23hg`,
	"boxShadowGrey": `buttonPill-module_boxShadowGrey__SHAqv`,
	"boxShadowPurple": `buttonPill-module_boxShadowPurple__CqRb3`,
	"fontSizeSmall": `buttonPill-module_fontSizeSmall__wjvX6`,
	"fontSizeMedium": `buttonPill-module_fontSizeMedium__RGf1x`,
	"regularContainer": `buttonPill-module_regularContainer__mwDGK`,
	"disabled": `buttonPill-module_disabled__T80RH`,
	"paddingMedium": `buttonPill-module_paddingMedium__15E8Z`,
	"padding": `buttonPill-module_padding__mp_iB`,
	"paddingSmall": `buttonPill-module_paddingSmall__KNOVH`,
	"paddingSmallIconRight": `buttonPill-module_paddingSmallIconRight__qKlgG`,
	"paddingSmallIconLeft": `buttonPill-module_paddingSmallIconLeft__ztDdd`,
	"backgroundWhite": `buttonPill-module_backgroundWhite__ChvOb`,
	"backgroundWhiteBase": `buttonPill-module_backgroundWhiteBase__YdK98`,
	"backgroundGrey": `buttonPill-module_backgroundGrey__zNdx8`,
	"backgroundPurple16Lc": `buttonPill-module_backgroundPurple16Lc__eWG0O`,
	"backgroundPurple100": `buttonPill-module_backgroundPurple100__Fracc`,
	"colorPurple_100": `buttonPill-module_colorPurple_100__OHy8G`,
	"colorPurple_40_tr": `buttonPill-module_colorPurple_40_tr__l4e0g`,
	"colorWhite_base": `buttonPill-module_colorWhite_base__eA6Jl`,
	"colorWhite_base_gradient": `buttonPill-module_colorWhite_base_gradient__oDBic`,
	"colorGrey_40_lc": `buttonPill-module_colorGrey_40_lc__l3nwv`,
	"colorBlack": `buttonPill-module_colorBlack__bsyqK`,
	"colorWhite_40_tr_base": `buttonPill-module_colorWhite_40_tr_base__lrIAU`,
	"fillContainer": `buttonPill-module_fillContainer__vKCg9`,
	"rightOrder": `buttonPill-module_rightOrder__J5IOX`,
	"containerMarginLeft4": `buttonPill-module_containerMarginLeft4__tS_5v`,
	"containerMarginLeft8": `buttonPill-module_containerMarginLeft8__Kpekw`,
	"containerMarginRight4": `buttonPill-module_containerMarginRight4__ObmLg`,
	"containerMarginRight8": `buttonPill-module_containerMarginRight8__CjiHk`
};
export default ___CSS_LOADER_EXPORT___;
